import { Box, Flex, Grid, Text, FlexProps } from '@chakra-ui/react';
import { IconLock } from 'icons';
import { ReactNode } from 'react';

interface TuneUpLevelBarProps extends FlexProps {
  title?: string;
  icon?: ReactNode;
  tunedUpIcon?: ReactNode;
  maxValue: number;
  currentValue: number;
  numberOfBars?: number;
  isLockedStat?: boolean;
  isTunedUp?: boolean;
  tuneUpDirection?: 'up' | 'down';
}

export const TuneUpLevelBar = ({
  title,
  icon,
  tunedUpIcon,
  maxValue,
  currentValue,
  numberOfBars = 6,
  isLockedStat = false,
  isTunedUp = false,
  tuneUpDirection = 'up',
  ...flexProps
}: TuneUpLevelBarProps) => {
  const backgroundColor = tuneUpDirection === 'up' ? 'rgba(38, 166, 154, 0.1)' : 'rgba(255, 0, 4, 0.1)';
  const backgroundBar = tuneUpDirection === 'up' ? 'linear-gradient(90deg, rgba(38, 166, 154, 0) 0%, #26A69A 50%, #00FFFF 100%)' : 'linear-gradient(90deg, #FF0004 0%, #D83832 50%, rgba(216, 56, 50, 0) 100%)'


  return (
    <Flex 
      gap={{ base: '0.25rem', md: '0.5rem' }} 
      alignItems="center" 
      w="full"
      px={{ base: '1', md: '2' }}
      py="1"
      {...flexProps}
      background={
        isTunedUp 
        ? 'linear-gradient(180deg, rgba(255, 255, 153, 0) 0%, rgba(255, 255, 153, 0.12) 100%)'
        : 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.06) 100%)'
      }
      position="relative"
      _before={isTunedUp ? {
        content: '""',
        position: 'absolute',
        borderRadius: '0.25rem',
        inset: 0,
        background: 'linear-gradient(360deg, rgba(229, 186, 85, 0.6) 0%, rgba(229, 186, 85, 0) 100%)',
        zIndex: -1,
        padding: '2px',
        mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        maskComposite: 'exclude',
      } : undefined}
      opacity={isLockedStat ? 0.6 : 1}
      borderRadius="0.25rem"
    >
      {icon && (
        <Box>
          {isLockedStat ? (
            <IconLock __css={{ path: { fill: 'white.80' } }} w={{ base: '1rem', md: '1.25rem' }} h={{ base: '1rem', md: '1.25rem' }} />
          ) : (
            isTunedUp ? tunedUpIcon : icon
          )}
        </Box>
      )}
      <Flex gap="0.25rem" color="white.100" flexDir="column" w="full">
        {title && (
          <Flex w="full" justifyContent="space-between" alignItems="center">
            <Text
              textTransform="capitalize"
              fontSize={{ base: '10px', md: '12px' }}
              lineHeight={{ base: '12px', md: '14px' }}
              noOfLines={1}
              fontWeight="500"
              color="white.80"
              flex="1"
            >
              {title}
            </Text>
          </Flex>
        )}
        <Flex
          w="full"
          h="6px"
          background={backgroundColor}
          borderRadius="0.25rem"
          p="0.25rem"
          box-shadow="0px 1px 3px 1px rgba(0, 0, 0, 0.15)"
          alignItems="center"
          justifyContent="center"
        >
          <Box 
            w="full"
            h="2px"
            background={backgroundBar}
            borderRadius="0.125rem"
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
